import { useNavigate } from "react-router-dom";
import { BsChevronLeft } from "react-icons/bs";

export default function BackLink() {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(-1)}
      className="bg-gray-200 w-full text-black flex justify-start p-2 border-b border-gray-300"
    >
      <BsChevronLeft /> <span className="text-xs">Back</span>
    </button>
  );
}
